export const fontWeights = {
  semibold: 600,
  medium: 500,
  regular: 400,
};

export type FontWeights = keyof typeof fontWeights;
